import { PrimaryRating } from "../../shared";

export const getPrimaryRatingColor = (colorCode: PrimaryRating) => {
    if (colorCode === "BLUE") return "#1E54B9";
    if (colorCode === "YELLOW") return "#EDD765";
    if (colorCode === "RED") return "#C21C1C";
    return "#B7B7B7";
}